// SignIn.js

import React, { useEffect, useState } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { sharedLogin, requestLoginOtp, verifyLoginOtp } from "../components/api2";
import { toast } from "react-toastify";
import logo from "../assets/logos/hobo-logo.png";
import backgroundLeft from "../assets/sign-in-sign-up-background.png";
import haldirams from "../assets/logos/haldirams.svg";
import barbequeNation from "../assets/logos/barbeque-nation.svg";
import wipro from "../assets/logos/wipro.svg";
import assembly from "../assets/logos/assembly.svg";
import reviewer from "../assets/icons/reviewer.svg";
import influencerOne from "../assets/influencer-anita-singh.png";
import influencerTwo from "../assets/influencer-pragya-mukherjee.jpg";
import star from "../assets/icons/star.svg";
import openQuote from "../assets/icons/open-quote.svg";
import endQuote from "../assets/icons/end-quote.svg";
import calender from "../assets/icons/calender.svg";
import hero from "../assets/influencer-sign-in-sign-up-hero-frame.png";
import tag from "../assets/influencer-sign-in-sign-up-hero-tag.png";
import { Config } from "../.env.js";
import AnimatedCounter from "../components/AnimatedCounter";
import BrandLogoCarousel from "../components/BrandLogoCarousel";
import BackButton from "../components/BackButton";
import { Helmet } from "react-helmet-async";
import AutoScrollTestimonialsInfluencer from "../components/AutoScrollTestimonialsInfluencer";
import Logo from "../components/Logo";
import { COPYRIGHT_TEXT } from "../utils/resolve";
import useRedirectIfAuthenticated, {
  POST_LOGIN_REDIRECT_KEY,
} from "../utils/useRedirectIfAuthenticated";

const Login = ({ roleOverride } = {}) => {
  const [Email, setEmail] = useState("");
  const [Password, setPassword] = useState("");
  const [brandName, setBrandName] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loginMode, setLoginMode] = useState("password"); // "password" | "otp"
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpVerifyLoading, setOtpVerifyLoading] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const location = useLocation();
  const [searchParams] = useSearchParams();
  // SEO URL restructure: role now comes from the path (/member/signin, /brand/signin);
  // the legacy ?role= query param is still honoured as a fallback.
  const roleParam = roleOverride || searchParams.get("role");
  // Set by the creators app's application form when a creator chooses to
  // continue with their previous account ("Use my previous account"): where
  // to go back to after signing in (a /creators/ path only) and that
  // account's email.
  const nextParam = searchParams.get("next") || "";
  const creatorReturnPath =
    nextParam.startsWith("/creators/") && !nextParam.startsWith("//")
      ? nextParam
      : "";
  const previousAccountHint = searchParams.get("account") || "";

  useEffect(() => {
    if (previousAccountHint) setEmail(previousAccountHint);
  }, [previousAccountHint]);

  useRedirectIfAuthenticated();

  useEffect(() => {
    if (resendTimer <= 0) return undefined;
    const interval = setInterval(() => {
      setResendTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, [resendTimer]);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword); // Toggle showPassword state
  };

  // const [credentials, setCredentials] = useState({
  //     email: '',
  //     password: ''
  // });
  const redirectForRole = (role) => {
    const normalizedRole = String(role || "").toLowerCase();

    if (normalizedRole === "brand" || normalizedRole.startsWith("brand-")) {
      return `${Config.SITE_URL}/creators/brand/home`;
    }

    return `${Config.SITE_URL}/creators/campaigns/live-brand-collaboration-campaigns`;
  };

  const setStoredValue = (key, value) => {
    localStorage.setItem(key, value);
    sessionStorage.setItem(key, value);
  };

  const setStoredJSON = (key, value) => {
    if (value === undefined) return;
    const serialized = JSON.stringify(value);
    localStorage.setItem(key, serialized);
    sessionStorage.setItem(key, serialized);
  };

  const toAbsoluteUrl = (path) => {
    if (!path) return "";
    if (path.startsWith("http://") || path.startsWith("https://")) {
      return path;
    }

    return `${Config.SITE_URL}${path}`;
  };

  const removeStoredValue = (key) => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  };

  const resetAuthState = () => {
    [
      "token",
      "authToken",
      "userRole",
      "role",
      "authRole",
      "loggedInUserName",
      "loggedInUserId",
      "email",
      "userEmail",
      "Brand Email",
      "isSignedUp",
      "isloggedIn",
      "authUser",
      "signupRole",
      "brandSignupUser",
      "brandCreatorUser",
      "reviewerUser",
      "brandUser",
      "communityBrand",
      "communityBrandId",
      "brandId",
      "brandUserId",
      "communityBrandName",
      "brandUniqueId",
      "communityMarketingBrandName",
      "brandModules",
      "pendingBrandModules",
      "brandName",
      "influencer",
      POST_LOGIN_REDIRECT_KEY,
    ].forEach(removeStoredValue);
  };

  const persistAuthState = (res) => {
    const authRole = String(res.authRole || res.role || "member").toLowerCase();
    const storageRole =
      String(res.userRole || "").toLowerCase() ||
      (authRole === "member" ? "influencer" : authRole);
    const emailValue = res.user?.Email || Email;
    const modules = Array.isArray(res.modules) ? res.modules : [];
    const hasCreatorMarketing = modules.includes("creatorMarketing");
    const hasCommunityMarketing = modules.includes("communityMarketing");
    const creatorBrandUser = hasCreatorMarketing
      ? res.profiles?.brandUser || res.profiles?.influencerUser || null
      : null;
    const communityBrandName = hasCommunityMarketing
      ? res.communityBrandName || res.profiles?.communityBrand?.brandName || ""
      : "";
    const brandNameList = Array.isArray(res.brandName) ? res.brandName : [];
    const storedBrandName = brandNameList.length
      ? brandNameList
      : communityBrandName
      ? [communityBrandName]
      : [];
    const communityBrandId =
      hasCommunityMarketing
        ? res.profiles?.communityBrandId || res.profiles?.communityBrand?._id || ""
        : "";
    const brandId = hasCreatorMarketing
      ? res.profiles?.brandId || res.profiles?.brand?._id || ""
      : "";
    const brandUserId = creatorBrandUser?._id || "";
    const creatorUserId =
      creatorBrandUser?._id || res.profiles?.influencerUser?._id || "";
    const loggedInUserId =
      communityBrandId || brandUserId || creatorUserId || res.user?._id || "";
    const loggedInName =
      communityBrandName ||
      res.profiles?.reviewerUser?.yourName ||
      creatorBrandUser?.yourName ||
      res.profiles?.influencerUser?.yourName ||
      res.user?.FullName ||
      "";
    const effectiveRedirect =
      authRole === "brand" && hasCommunityMarketing && !hasCreatorMarketing
        ? `${Config.SITE_URL}/community/brand/home?page=1`
        : authRole === "member" && creatorReturnPath
        ? toAbsoluteUrl(creatorReturnPath)
        : toAbsoluteUrl(res.redirectTo || redirectForRole(res.role));

    resetAuthState();

    setStoredValue("lastActivity", Date.now().toString());
    setStoredValue("token", res.token);
    setStoredValue("authToken", res.token);
    setStoredValue("userRole", storageRole);
    setStoredValue("role", storageRole);
    setStoredValue("authRole", authRole);
    setStoredValue("loggedInUserName", loggedInName);
    setStoredValue("loggedInUserId", loggedInUserId);
    if (brandId) {
      setStoredValue("brandId", brandId);
    }
    if (communityBrandId) {
      setStoredValue("communityBrandId", communityBrandId);
    }
    setStoredValue("email", emailValue);
    setStoredValue("userEmail", emailValue);
    setStoredValue("Brand Email", emailValue);
    setStoredValue("isSignedUp", "true");
    setStoredValue("isloggedIn", "true");
    setStoredValue(POST_LOGIN_REDIRECT_KEY, effectiveRedirect);

    setStoredJSON("authUser", res.authUser || res.user || null);

    if (authRole === "brand") {
      setStoredValue("signupRole", "brand");
      setStoredJSON("brandSignupUser", res.authUser || res.user || null);
      setStoredJSON("brandModules", modules);
    } else {
      setStoredValue("signupRole", "member");
    }

    if (res.brandName && storedBrandName.length) {
      setStoredJSON("brandName", storedBrandName);
    }

    if (communityBrandName) {
      setStoredValue("communityBrandName", communityBrandName);
      setStoredValue("communityMarketingBrandName", communityBrandName);
    }

    if (hasCommunityMarketing && res.profiles?.communityBrand?.brandUniqueId) {
      setStoredValue("brandUniqueId", res.profiles.communityBrand.brandUniqueId);
    }

    if (creatorBrandUser) {
      setStoredJSON("brandUser", creatorBrandUser);
    }

    if (brandUserId && creatorBrandUser) {
      setStoredValue("brandUserId", brandUserId);
    }

    if (hasCreatorMarketing && creatorBrandUser) {
      setStoredJSON("influencer", creatorBrandUser);
      setStoredJSON("brandCreatorUser", creatorBrandUser);
    } else if (authRole === "member" && res.profiles?.influencerUser) {
      setStoredJSON("influencer", res.profiles.influencerUser);
    }

    if (res.profiles?.reviewerUser) {
      setStoredJSON("reviewerUser", res.profiles.reviewerUser);
    }

    if (hasCommunityMarketing && res.profiles?.communityBrand) {
      setStoredJSON("communityBrand", res.profiles.communityBrand);
    }

    if (storedBrandName.length) {
      setStoredJSON("brandName", storedBrandName);
    }

    if (res.user?.FullName && !communityBrandName) {
      setStoredValue("loggedInUserName", res.user.FullName);
    }

    return effectiveRedirect;
  };

  // const handleChange = (e) => {
  //     const { name, value } = e.target;
  //     setCredentials({ ...credentials, [name]: value });
  // };

  // const setLoggedIn = (isLoggedIn) => {
  //     localStorage.setItem('isLoggedIn', isLoggedIn);
  // };

  // Helper function to get logged-in state from local storage
  // const getLoggedIn = () => {
  //     const isLoggedIn = localStorage.getItem('isLoggedIn');
  //     return isLoggedIn === 'true';
  // };

  // useEffect(() => {
  //     const isLoggedIn = getLoggedIn();
  //     if (isLoggedIn) {
  //         navigate("/internal/home", { replace: true });
  //     }
  // }, [navigate]);

  const handlesignin = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const res = await sharedLogin({
        email: Email,
        password: Password,
        loginType: roleParam,
      });

      if (!res.error) {
        // Brand on a temporary password: server returns only a reset redirect
        // (no session token). Don't run persistAuthState.
        if (res.mustResetPassword && res.redirectTo) {
          window.location.replace(res.redirectTo);
          return;
        }
        const redirectTo = persistAuthState(res);
        window.location.replace(redirectTo);
      } else {
        toast.error(res.error);
      }
    } catch (err) {
      // Handle error
    } finally {
      setLoading(false);
    }
  };

  const handleSendOtp = async () => {
    if (!Email) return;
    try {
      setOtpLoading(true);
      const res = await requestLoginOtp({ email: Email });
      if (!res.error) {
        toast.success(res.message || "OTP sent to your registered email");
        setOtpSent(true);
        setResendTimer(60);
      } else {
        toast.error(res.error);
      }
    } catch (err) {
      toast.error("Unable to send OTP. Please try again.");
    } finally {
      setOtpLoading(false);
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    if (!otp) return;
    try {
      setOtpVerifyLoading(true);
      const res = await verifyLoginOtp({ email: Email, otp, loginType: roleParam });

      if (!res.error) {
        if (res.mustResetPassword && res.redirectTo) {
          window.location.replace(res.redirectTo);
          return;
        }
        const redirectTo = persistAuthState(res);
        window.location.replace(redirectTo);
      } else {
        toast.error(res.error);
      }
    } catch (err) {
      toast.error("Unable to verify OTP. Please try again.");
    } finally {
      setOtpVerifyLoading(false);
    }
  };

  const switchToOtpMode = () => {
    setLoginMode("otp");
    setOtpSent(false);
    setOtp("");
    setResendTimer(0);
  };

  const switchToPasswordMode = () => {
    setLoginMode("password");
    setOtpSent(false);
    setOtp("");
    setResendTimer(0);
  };

  return (
    <>
      <Helmet>
        <title>Log In | Hobo.Video Creator Dashboard</title>
        <meta
          name="description"
          content="Access your Hobo.Video dashboard to manage campaigns, track earnings, and connect with brands on India’s trusted influencer marketing platform."
        />
        <meta
          property="og:title"
          content="Log In | Hobo.Video Creator Dashboard"
        />
        <meta
          property="og:description"
          content="Access your Hobo.Video dashboard to manage campaigns, track earnings, and connect with brands on India’s trusted influencer marketing platform."
        />
      </Helmet>
      {/* <div className="imgfull">
        <div className="container1 has-text-centered">
          <div className="logo-card">
            <figure className="w-[115px]">
              <img src={logo} alt="Logo" />
            </figure>
          </div>
          <h1 className="title mt-3 has-text-white">
            Sign In to Your Influencer Dashboard
          </h1>
          {previousAccountHint && (
            <p className="has-text-white mb-3">
              Sign in to your previous account ({previousAccountHint}) to
              continue your application.
            </p>
          )}
          <div className="form-container px-2">
            <form>
              <div className="my-2   has-text-left my-input">
                <label className="label has-text-white">
                  Your Email Registered With Hobo.Video
                </label>
              </div>
              <div className="field">
                <div className="control has-icons-left my-input">
                  <input
                    className="input is-rounded "
                    type="text"
                    placeholder="Email ID"
                    name="email"
                    value={Email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <span className="icon is-small is-left">
                    <i className="fas fa-envelope"></i>
                  </span>
                </div>
              </div>
              <div className="my-2 has-text-left my-input">
                <label className="label has-text-white">Password</label>
              </div>
              <div className="field">
                <div className="control has-icons-left has-icons-right is-flex my-input">
                  <input
                    className="input is-rounded"
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    value={Password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <span className="icon is-small is-left">
                    <i className="fas fa-key"></i>
                  </span>
                  <span
                    className="icon is-small is-right"
                    onClick={togglePasswordVisibility}
                    style={{ cursor: "pointer", pointerEvents: "all" }}
                  >
                    <i
                      className={`fas fa-eye${showPassword ? "-slash" : ""}`}
                    ></i>
                  </span>
                </div>
              </div>
              <div className="Link mb-3">
                <Link
                  to="/forgot-password"
                  state={{ previousPath: location.pathname }}
                >
                  {console.log("Previous Path:", location.pathname)}
                  <p className="has-text-right my-input">
                    Forgot Your Password?
                  </p>
                </Link>
              </div>
              <div className="field">
                <div className="control my-input">
                  <button
                    className="button is-primary is-rounded is-focused is-medium is-fullwidth"
                    disabled={!Email || !Password || loading}
                    type="submit"
                    onClick={handlesignin}
                  >
                    {loading ? "Loading..." : "SIGN IN"}
                  </button>
                </div>
              </div>

              <div
                className="is-flex is-justify-content-flex-end has-text-left mt-3 my-input"
                // style={{ marginLeft: "12rem" }}
              >
                <p className="has-text-white">Don't have an account?</p>
                <Link to="/influencer-signup">
                  <span className="has-text-weight-bold ml-2">Sign Up</span>
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div> */}

      {/* New UI */}
      <div className="flex min-h-screen">
        <div
          className="hidden xl:flex w-[55%] px-6 pt-[50px] pb-[100px] text-center flex-col items-center justify-center"
          style={{
            backgroundImage: `url(${backgroundLeft})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            // backgroundPosition: "center",
          }}
        >
          <div className="absolute top-[25px] left-[50px]">
            <BackButton />
          </div>
          <h1 className="text-[27px] leading-[135%] text-white">
            {roleParam === "brand"
              ? "Welcome Back, Brand"
              : "Welcome Back, Member"}
          </h1>
          <p className="w-[322px] text-[11px] text-white leading-[169%] mt-[9px]">
            Access your dashboard, manage campaigns, and pick up right where you
            left off.
          </p>

          <div className="relative mt-[20px] mb-[54px]">
            <div className="bg-white rounded-md w-[130px] p-4 h-[157px] flex flex-col justify-center absolute top-[15px] left-[-15%] gap-[5px] items-center">
              <p className="text-[8px] text-black font-medium leading-[143%]">
                Hassle-Free Partnerships with Verified Brands
              </p>
            </div>
            <div className="flex">
              <img
                src={tag}
                className="absolute w-[150px] top-[180px] left-[-134px]"
              ></img>
              <img src={hero} className="mt-6 w-[350px]"></img>
            </div>
            <div className="bg-white flex flex-row items-center justify-center p-3 rounded-md gap-[5px] absolute bottom-[134px] right-[-143px]">
              <img src={calender}></img>
              <p className="text-[10px] text-[#030308] font-medium leading-[15px]">
                Timely <span className="text-[#FF2F5E] font-bold">Payouts</span>
              </p>
            </div>
            {/* <div className="w-[195px] bg-white flex flex-row items-center justify-center py-3 px-5 rounded-md gap-[27px] absolute bottom-[58px] right-[-11%]">
              <div className="">
                <AnimatedCounter
                  target={12000}
                  duration={3000}
                  className="text-[#FF2F5E] text-[15px] font-semibold tracking-[-1px]"
                />
                <p className="text-[#030308] text-[10px] mt-[5px]">Brands</p>
              </div>
              <div className="">
                <AnimatedCounter
                  target={150000}
                  duration={3000}
                  className="text-[#FF2F5E] text-[15px] font-semibold tracking-[-1px]"
                />
                <p className="text-[#030308] text-[10px] mt-[5px]">
                  Collabs done
                </p>
              </div>
            </div> */}
            <div className="w-[195px] bg-white flex flex-row items-center justify-center py-3 px-5 rounded-md gap-[27px] absolute bottom-[59px] right-[-32%]">
              {/* Brands Counter */}
              <div className="text-center w-[60px]">
                <div className="w-full flex justify-center">
                  <AnimatedCounter
                    target={12000}
                    duration={3000}
                    className="text-[#FF2F5E] text-[15px] font-semibold tracking-[-1px]"
                  />
                </div>
                <p className="text-[#030308] text-[10px] mt-[5px]">Brands</p>
              </div>

              {/* Collabs Counter */}
              <div className="text-center w-[80px]">
                <div className="w-full flex justify-center">
                  <AnimatedCounter
                    target={150000}
                    duration={3000}
                    className="text-[#FF2F5E] text-[15px] font-semibold tracking-[-1px]"
                  />
                </div>
                <p className="text-[#030308] text-[10px] mt-[5px]">
                  Collabs done
                </p>
              </div>
            </div>
          </div>
          {/* <div className="mt-[54px] flex gap-[22px] relative">
            <img
              src={openQuote}
              className="absolute left-[-16px] top-[-17px]"
            ></img>
            <div className="border border-[#999999] p-4 rounded flex-1">
              <div className="flex gap-[10px] items-center">
                <img
                  src={influencerOne}
                  alt=""
                  className="w-[41px] h-[41px] rounded-[50%]"
                ></img>
                <div className="text-white text-left leading-[16px]">
                  <p className="text-[12px] font-medium">Anita Singh</p>
                  <p className="text-[11px] max-w-[120px]">
                    Lifestyle, Home Decor, Food, Skincare.
                  </p>
                </div>
                <div className="flex">
                  {[...Array(5)].map((_, i) => (
                    <img key={i} src={star} alt="star" className="w-5 h-5" />
                  ))}
                </div>
              </div>
              <p className="text-[9px] font-medium text-white text-left mt-[10px]">
                "Working with Hobo was such a smooth and amazing experience,
                super professional, easy coordination, and everything went
                perfectly."
              </p>
            </div>
            <div className="border border-[#999999] p-4 rounded flex-1">
              <div className="flex gap-[10px] items-center">
                <img
                  src={influencerTwo}
                  alt=""
                  className="w-[41px] h-[41px] rounded-[50%]"
                ></img>
                <div className="text-white text-left leading-[16px]">
                  <p className="text-[12px] font-medium">Pragya Mukherjee </p>
                  <p className="text-[11px] max-w-[120px]">
                    Lifestyle, Travel, Fashion.
                  </p>
                </div>
                <div className="flex">
                  {[...Array(5)].map((_, i) => (
                    <img key={i} src={star} alt="star" className="w-5 h-5" />
                  ))}
                </div>
              </div>
              <p className="text-[9px] font-medium text-white text-left mt-[10px]">
                "Such a great collaboration experience! The team is super
                professional, creative, and easy to work with. Everything felt
                effortless and well-coordinated. I highly recommend working with
                them! 💫"
              </p>
            </div>
            <img
              src={endQuote}
              className="absolute right-[-16px] bottom-[-17px]"
            ></img>
          </div> */}
          <AutoScrollTestimonialsInfluencer />
          <h2 className="text-[15px] font-semibold text-white leading-[33px] tracking-[1%] mt-[31px]">
            Trusted by 12,000+ Brands Worldwide
          </h2>
          {/* <div className="mt-[25px] flex flex-row gap-[39px]">
            <img src={haldirams}></img>
            <img src={barbequeNation}></img>
            <img src={hcah}></img>
            <img src={wipro}></img>
            <img src={assembly}></img>
          </div> */}
          <BrandLogoCarousel />
        </div>
        <div className="w-full xl:w-[45%] flex flex-col items-center pt-[60px] bg-white">
          <div className="xl:hidden absolute top-[25px] left-[20px]">
            <BackButton />
          </div>
          {/* <img src={logo} alt="Logo" className="w-[125px]" /> */}
          <Logo src={logo} className="w-[75px]" />

          <h1 className="text-[25px] font-medium text-[#858585] leading-[169%] mt-[12px]">
            Welcome to{" "}
            <span className="text-[#494949] font-semibold">Hobo.Video!</span>
          </h1>
          <div className="form-container px-2">
            <div className="w-full h-[40px] mt-[15px] rounded border border-[#CECECE] flex flex-row justify-between items-center">
              <p className="flex-1 text-center text-white bg-black text-[12px] font-medium leading-[169%] rounded py-[7px] ml-[2px]">
                LOG IN
              </p>
              <Link
                to={
                  roleParam
                    ? `/${roleParam === "brand" ? "brand" : "member"}/signup`
                    : "/signup"
                }
                className="flex-1"
              >
                <p className="w-full text-center text-[12px] font-medium leading-[169%] text-black">
                  SIGN UP
                </p>
              </Link>
            </div>
            <form className="mt-[30px] flex flex-col gap-[30px]">
              <div className="relative w-full">
                <label className="absolute -top-2 left-[12px] bg-white px-1 text-[10px] font-medium text-black leading-[169%]">
                  Your email address
                </label>
                <input
                  // className="input is-rounded "
                  className="w-full h-[45px] border border-[#CECECE] rounded px-4 py-5 text-black placeholder:text-[#8A8A8A] text-sm font-medium leading-[169%]"
                  type="text"
                  placeholder="Email Address"
                  name="email"
                  value={Email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              {loginMode === "password" && (
                <>
                  <div className="relative w-full flex mb-[-10px]">
                    <label className="absolute -top-2 left-[12px] bg-white px-1 text-[10px] font-medium text-black leading-[169%]">
                      Password must contain 8 characters or more
                    </label>
                    <input
                      // className="input is-rounded"
                      className="w-full h-[45px] border border-[#CECECE] rounded px-4 py-5 text-black placeholder:text-[#8A8A8A] text-sm font-medium leading-[169%]"
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      value={Password}
                      onChange={(e) => setPassword(e.target.value)}
                    />

                    <span
                      className="icon is-small is-right absolute right-[10px] top-[35%]"
                      onClick={togglePasswordVisibility}
                      style={{ cursor: "pointer", pointerEvents: "all" }}
                    >
                      <i
                        className={`fas fa-eye${showPassword ? "-slash" : ""}`}
                      ></i>
                    </span>
                  </div>

                  <div className="Link flex flex-col items-end">
                    <Link
                      to="/forgot-password"
                      state={{ previousPath: location.pathname }}
                      className="text-[12px] font-semibold text-black text-right underline leading-[169%]"
                    >
                      {/* {console.log("Previous Path:", location.pathname)} */}
                      Forgot Password?
                    </Link>
                  </div>

                  <div className="flex flex-col gap-[12px]">
                    <button
                      // className="button is-primary is-rounded is-focused is-medium is-fullwidth"
                      className="bg-black rounded w-full h-[45px] text-white text-[12px] font-medium leading-[169%] disabled:cursor-not-allowed disabled:opacity-40"
                      disabled={!Email || !Password || loading}
                      type="submit"
                      onClick={handlesignin}
                    >
                      {loading ? "Loading..." : "Sign In"}
                    </button>

                    <button
                      type="button"
                      onClick={switchToOtpMode}
                      className="bg-white border border-black rounded w-full h-[45px] text-black text-[12px] font-medium leading-[169%]"
                    >
                      Sign In with OTP
                    </button>
                  </div>
                </>
              )}

              {loginMode === "otp" && (
                <>
                  {otpSent && (
                    <div className="relative w-full">
                      <label className="absolute -top-2 left-[12px] bg-white px-1 text-[10px] font-medium text-black leading-[169%]">
                        Enter the OTP sent to your email
                      </label>
                      <input
                        className="w-full h-[45px] border border-[#CECECE] rounded px-4 py-5 text-black placeholder:text-[#8A8A8A] text-sm font-medium leading-[169%]"
                        type="text"
                        inputMode="numeric"
                        maxLength={6}
                        placeholder="Enter OTP"
                        value={otp}
                        onChange={(e) =>
                          setOtp(e.target.value.replace(/\D/g, ""))
                        }
                      />
                    </div>
                  )}

                  <div className="Link flex flex-row justify-between items-center">
                    <button
                      type="button"
                      onClick={switchToPasswordMode}
                      className="text-[12px] font-semibold text-black text-left underline leading-[169%]"
                    >
                      Sign In with Password
                    </button>
                    {otpSent && (
                      <button
                        type="button"
                        onClick={handleSendOtp}
                        disabled={resendTimer > 0 || otpLoading}
                        className="text-[12px] font-semibold text-black text-right underline leading-[169%] disabled:opacity-40"
                      >
                        {resendTimer > 0
                          ? `Resend OTP in ${resendTimer}s`
                          : "Resend OTP"}
                      </button>
                    )}
                  </div>

                  <div className="">
                    {otpSent ? (
                      <button
                        className="bg-black rounded w-full h-[45px] text-white text-[12px] font-medium leading-[169%] disabled:cursor-not-allowed disabled:opacity-40"
                        disabled={!otp || otpVerifyLoading}
                        type="submit"
                        onClick={handleVerifyOtp}
                      >
                        {otpVerifyLoading ? "Verifying..." : "Verify OTP"}
                      </button>
                    ) : (
                      <button
                        className="bg-black rounded w-full h-[45px] text-white text-[12px] font-medium leading-[169%] disabled:cursor-not-allowed disabled:opacity-40"
                        disabled={!Email || otpLoading}
                        type="button"
                        onClick={handleSendOtp}
                      >
                        {otpLoading ? "Sending OTP..." : "Send OTP"}
                      </button>
                    )}
                  </div>
                </>
              )}
            </form>
            <p className="text-[12px] text-[#494949] font-medium leading-[169%] mt-[39px] text-center">
              {COPYRIGHT_TEXT}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
